// PHP specific fonts
// Freight Big Pro Black
import FreightBigProBlackWoffSrc from "@theme/fonts/FreightBigProBlack/freight-big-pro-black.woff";
import FreightBigProBlackWoff2Src from "@theme/fonts/FreightBigProBlack/freight-big-pro-black.woff2";
import GraphikMediumWoffSrc from "@theme/fonts/Graphik/graphik-medium-web.woff";
import GraphikMediumWoff2Src from "@theme/fonts/Graphik/graphik-medium-web.woff2";
import GraphikRegularWoffSrc from "@theme/fonts/Graphik/graphik-regular-web.woff";
import GraphikRegularWoff2Src from "@theme/fonts/Graphik/graphik-regular-web.woff2";
import GraphikSemiBoldWoffSrc from "@theme/fonts/Graphik/graphik-semibold-web.woff";
import GraphikSemiBoldWoff2Src from "@theme/fonts/Graphik/graphik-semibold-web.woff2";
//MS Sans
import MsSansWoffSrc from "@theme/fonts/MsSans/MANSCAPED_beta03.woff";
import MsSansWoff2Src from "@theme/fonts/MsSans/MANSCAPED_beta03.woff2";

interface FontFaceOptions {
  fontFamily: string;
  fontWeight: string | number;
  fontStyle: string;
  fallback: string;
  fontUrls: {
    src: string;
    format: string;
  }[];
  preload?: boolean;
}

/**
 * Describes a @font-face web font.
 *
 * Stringified, it can be used as a `font-family` value,
 * i.e.,
 *
 *     css`font-family: ${String(fontface)}`
 */
export interface FontFace extends FontFaceOptions {
  toString(): string;
}

function createFontFace(options: FontFaceOptions): FontFace {
  return Object.assign({}, options, {
    toString() {
      return `${options.fontFamily}, ${options.fallback}`;
    },
  });
}

export const GraphikRegular = createFontFace({
  fontFamily: "Graphik",
  fontWeight: 400,
  fontStyle: "normal",
  fallback: "sans-serif",
  fontUrls: [
    { src: GraphikRegularWoff2Src, format: "woff2" },
    { src: GraphikRegularWoffSrc, format: "woff" },
  ],
  preload: true,
});

export const GraphikMedium = createFontFace({
  fontFamily: "Graphik",
  fontWeight: 500,
  fontStyle: "normal",
  fallback: "sans-serif",
  fontUrls: [
    { src: GraphikMediumWoff2Src, format: "woff2" },
    { src: GraphikMediumWoffSrc, format: "woff" },
  ],
  preload: true,
});

export const GraphikSemiBold = createFontFace({
  fontFamily: "Graphik",
  fontWeight: 600,
  fontStyle: "normal",
  fallback: "sans-serif",
  fontUrls: [
    { src: GraphikSemiBoldWoff2Src, format: "woff2" },
    { src: GraphikSemiBoldWoffSrc, format: "woff" },
  ],
  preload: true,
});

export const MsSansFont = createFontFace({
  fontFamily: "MsSans",
  fontWeight: 600,
  fontStyle: "normal",
  fallback: "sans-serif",
  fontUrls: [
    { src: MsSansWoff2Src, format: "woff2" },
    { src: MsSansWoffSrc, format: "woff" },
  ],
  preload: true,
});

export const FreightBigProBlackFont = createFontFace({
  fontFamily: "freight-big-pro-black",
  fontWeight: 900,
  fontStyle: "normal",
  fallback: "serif",
  fontUrls: [
    { src: FreightBigProBlackWoff2Src, format: "woff2" },
    { src: FreightBigProBlackWoffSrc, format: "woff" },
  ],
  preload: true,
});
